export default __webpack_public_path__ + "static/mixingboard-975d27f623aa32ff9bfca0b5d6f1df7a.jpg";